import { render, staticRenderFns } from "./ImprintView.vue?vue&type=template&id=2b812e59"
import script from "./ImprintView.vue?vue&type=script&lang=js"
export * from "./ImprintView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports